/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function IceCreamIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "ice-cream", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M9.5 13.5L12.5 20.5L15.5 13.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M15.5 7.5C15.5 5.84315 14.1569 4.5 12.5 4.5C10.8431 4.5 9.5 5.84315 9.5 7.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 8.26389C11.9692 7.78885 11.2684 7.5 10.5 7.5C8.84315 7.5 7.5 8.84315 7.5 10.5C7.5 12.1569 8.84315 13.5 10.5 13.5C11.2684 13.5 11.9692 13.2111 12.5 12.7361", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("circle", { cx: 14.5, cy: 10.5, r: 3, stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(IceCreamIcon);
export default ForwardRef;
//# sourceMappingURL=iceCreamIcon.js.map